import { render, staticRenderFns } from "./addmodel.vue?vue&type=template&id=ced89660&scoped=true"
import script from "./addmodel.vue?vue&type=script&lang=js"
export * from "./addmodel.vue?vue&type=script&lang=js"
import style0 from "./addmodel.vue?vue&type=style&index=0&id=ced89660&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced89660",
  null
  
)

export default component.exports